import { Component, OnInit } from '@angular/core';
import { NavbarService } from './../navbar/navbar.service';
import { BaseService } from '../../shared-service/base.service';
import { WindowRef } from '../../shared-service/windowRef.service';

@Component({
	selector: 'notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

	constructor(private navbarService: NavbarService, public bs: BaseService ,private winRef: WindowRef) {

	}
	public EnableNotification: boolean = false;
	public EnableAnnouncement: boolean = false;
	storageHomePageOptionKey: PropertyKey = 'HomePageOptions';
	private storageAnnouncementDetailsKey: PropertyKey = 'AnnouncementDetailsKey';
	private params: Object = {};
	public AnnouncementDetail: Object|any = {};
	public NotificationDetail: Object|any = {};


	ngOnInit() {		
		this.navbarService.getPublicAnnouncementFromServer(this.params, this.storageAnnouncementDetailsKey).then((data:any) => {
			this.AnnouncementDetail = data;   
			this.bs.UnreadAnnouncementCount = this.AnnouncementDetail['TotalUnreadRecords'];
		  }, (data) => {
			this.bs.log('error','Error in getting list');
		  });
		  this.navbarService.getNotificatiionListFromServer(this.params, '***').then((data) => {
			this.NotificationDetail = data;   
			this.bs.UnreadNotificationCount = this.NotificationDetail['TotalUnreadRecords'];
		  }, (data) => {
			this.bs.log('error','Error in getting list');
		  });
		  
		if (this.bs.isActiveNotification) {
			this.bs.NotificationClass= "active";
			this.bs.AnnouncementClass= "";
			this.EnableAnnouncement = false;
			this.EnableNotification = true;
			this.winRef.nativeWindow.document.getElementById('notificationDiv').focus();
		}
		else {
			this.bs.NotificationClass= "";
			this.bs.AnnouncementClass= "active";
			this.EnableAnnouncement = true;
			this.EnableNotification = false;
		}
	}
	openNotification() {		
		this.bs.NotificationClass= "active";
		this.bs.AnnouncementClass= "";
		this.EnableAnnouncement = false;
		this.EnableNotification = true;
	}
	openAnnouncement() {
		this.bs.NotificationClass= "";
		this.bs.AnnouncementClass= "active";
		this.EnableAnnouncement = true;
		this.EnableNotification = false;

	}

}



